import { Facebook, Linkedin } from "lucide-react";
import { brand } from "@/data/site/brand";

type Variant = "footer" | "contact";

export const SocialLinks = ({
  variant = "footer",
  className = "",
}: {
  variant?: Variant;
  className?: string;
}) => {
  const links = [
    { href: brand.social.facebook, label: "Facebook", Icon: Facebook },
    { href: brand.social.linkedin, label: "LinkedIn", Icon: Linkedin },
  ].filter((l) => Boolean(l.href));

  const base =
    variant === "footer"
      ? "inline-flex items-center justify-center w-9 h-9 rounded-full border border-white/20 text-white/80 hover:text-navy hover:bg-gold hover:border-gold transition-colors"
      : "inline-flex items-center justify-center w-10 h-10 rounded-full border border-navy/15 text-navy hover:text-white hover:bg-navy transition-colors";

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {links.map(({ href, label, Icon }) => (
        <a
          key={label}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${brand.legalName} on ${label}`}
          className={base}
        >
          <Icon className="w-4 h-4" />
        </a>
      ))}
    </div>
  );
};
